<mat-icon [style.color]="value ? 'green' : 'red'">{{ value ? 'check' : 'close' }}</mat-icon>
